import { render, staticRenderFns } from "./CrearInstitucionTemporal.vue?vue&type=template&id=3ff38b5d"
import script from "./CrearInstitucionTemporal.vue?vue&type=script&lang=js"
export * from "./CrearInstitucionTemporal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports